'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _ethereumjsUtil = require('ethereumjs-util');

var _ethereumjsUtil2 = _interopRequireDefault(_ethereumjsUtil);

var _jsbiUtils = require('jsbi-utils');

var _nodeFetch = require('node-fetch');

var _nodeFetch2 = _interopRequireDefault(_nodeFetch);

var _transaction = require('./transaction');

var _transaction2 = _interopRequireDefault(_transaction);

var _outpoint = require('./outpoint');

var _outpoint2 = _interopRequireDefault(_outpoint);

var _output = require('./output');

var _output2 = _interopRequireDefault(_output);

var _input = require('./input');

var _input2 = _interopRequireDefault(_input);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Exit = function () {
  function Exit() {
    _classCallCheck(this, Exit);
  }

  _createClass(Exit, null, [{
    key: 'signOverExit',

    /**
                                                                                                                    * Returns:
                                                                                                                    * 0 -  32 bytes utxoId
                                                                                                                    * 32 -  32 bytes amount of money
                                                                                                                    * 64 -  32 bytes r-signature
                                                                                                                    * 96 -  32 bytes s-signature
                                                                                                                    * 128 - 31 bytes padding
                                                                                                                    * 159 -  1 byte v-signature
                                                                                                                    */
    value: function signOverExit(utxoId, amount, privKey) {
      var sigHashBuff = Exit.sigHashBuff(utxoId, amount);

      var sigHash = _ethereumjsUtil2.default.hashPersonalMessage(sigHashBuff);

      var sig = _ethereumjsUtil2.default.ecsign(sigHash, Buffer.from(privKey.replace('0x', ''), 'hex'));

      var vBuff = Buffer.alloc(32);
      vBuff.writeInt8(sig.v, 31);
      return Buffer.concat([sigHashBuff, sig.r, sig.s, vBuff]);
    }
    /**
       * params:
       * utxoId: string with 0x, e.g. 0x0000000000000000000000000000000000b447b980aea5accb5fd68789f6b099
       * amount: BigInt | number
       * returns:
       * 64 byte buffer
       */

  }, {
    key: 'sigHashBuff',
    value: function sigHashBuff(utxoId, amount) {
      var valueBuf = _ethereumjsUtil2.default.setLengthLeft(Buffer.from(_ethereumjsUtil2.default.padToEven(amount.toString(16)), 'hex'), 32);

      var utxoIdBuf = Buffer.from(utxoId.replace('0x', ''), 'hex');
      return Buffer.concat([utxoIdBuf, valueBuf]);
    }
  }, {
    key: 'bufferToBytes32Array',
    value: function bufferToBytes32Array(buffer) {
      var output = [];
      var offset = 0;

      for (var i = 0; i < buffer.length / 32; i++) {
        var bytes32 = '0x' + buffer.slice(offset, offset + 32).toString('hex');
        offset += 32;
        output.push(bytes32);
      }

      return output;
    }
  }, {
    key: 'txFromProof',
    value: function txFromProof(proof) {
      var tx = _transaction2.default.fromRaw(this.parseTxDataFromProof(proof));

      return tx;
    }
  }, {
    key: 'parseTxDataFromProof',
    value: function parseTxDataFromProof(proof) {
      var wordLength = 32;
      var buf = Buffer.alloc(proof.length * wordLength);

      for (var i = 0; i < proof.length; i++) {
        Buffer.from(proof[i].replace('0x', ''), 'hex').copy(buf, i * wordLength, 0, wordLength);
      }

      var offset = buf.readUInt8(32);
      var length = buf.readUInt16BE(34);
      var txData = Buffer.alloc(length);
      buf.copy(txData, 0, offset, offset + length);
      return txData;
    }
  }, {
    key: 'fastSellUTXO',
    value: function fastSellUTXO(utxo, plasmaChain, rootChain, marketMakerUrl, signer) {
      return plasmaChain.getConfig().then(function (nodeConfig) {
        var inputs = [new _input2.default(utxo.outpoint)];
        var outputs = [new _output2.default(utxo.output.value, nodeConfig.exitHandlerAddr, utxo.output.color)];

        var exitingUtxoTransfer = _transaction2.default.transfer(inputs, outputs);

        return Exit.fastSell(exitingUtxoTransfer, plasmaChain, rootChain, marketMakerUrl, signer);
      });
    }
  }, {
    key: 'fastSellAmount',
    value: function fastSellAmount(account, amount, color, plasmaChain, rootChain, marketMakerUrl, signer) {
      return Promise.all([plasmaChain.getUnspent(account), plasmaChain.getConfig()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            unspent = _ref2[0],
            nodeConfig = _ref2[1];

        var exitingUtxoTransfer = _transaction2.default.transferFromUtxos(unspent, account, nodeConfig.exitHandlerAddr, amount, color);

        return Exit.fastSell(exitingUtxoTransfer, plasmaChain, rootChain, marketMakerUrl, signer);
      });
    }
  }, {
    key: 'fastSell',
    value: function fastSell(spendTx, plasmaChain, rootChain, marketMakerUrl, signer) {
      var amount = (0, _jsbiUtils.bi)(spendTx.outputs[0].value);
      return (signer ? signer.signTx(spendTx) : spendTx.signWeb3(rootChain)).then(function (signedTx) {
        return plasmaChain.eth.sendSignedTransaction(signedTx.hex());
      }).then(function (transferTx) {
        var tx = _transaction2.default.fromRaw(transferTx.raw);

        var utxoId = new _outpoint2.default(tx.hash(), 0).getUtxoId();
        var sigHashBuff = Exit.sigHashBuff(utxoId, amount);
        var sigHash = '0x' + sigHashBuff.toString('hex');
        return Promise.all([plasmaChain.eth.getTransaction(_ethereumjsUtil2.default.bufferToHex(tx.inputs[0].prevout.hash)), signer ? signer.signMessage(sigHash) : _transaction2.default.signMessageWithWeb3(rootChain, sigHash)]).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              inputTx = _ref4[0],
              sig = _ref4[1];

          var vBuff = Buffer.alloc(32);
          vBuff.writeInt8(sig.v, 31);
          var signedData = Exit.bufferToBytes32Array(Buffer.concat([sigHashBuff, Buffer.from(sig.r), Buffer.from(sig.s), vBuff]));
          var setup = {
            inputTx: inputTx,
            tx: transferTx,
            effectiveBlock: (0, _helpers.periodBlockRange)(transferTx.blockNumber)[1],
            signedData: signedData
          };
          return (0, _nodeFetch2.default)(marketMakerUrl, {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(setup)
          }).then(function (response) {
            return response.json();
          });
        });
      });
    }
  }]);

  return Exit;
}();

exports.default = Exit;
module.exports = exports['default'];